import { render } from "./Collaboration.vue?vue&type=template&id=c2e54244&scoped=true"
import script from "./Collaboration.vue?vue&type=script&lang=js"
export * from "./Collaboration.vue?vue&type=script&lang=js"

import "./Collaboration.vue?vue&type=style&index=0&id=c2e54244&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e54244"]])

export default __exports__